import { render, staticRenderFns } from "./WarningOption.vue?vue&type=template&id=55310138"
import script from "./WarningOption.vue?vue&type=script&lang=js"
export * from "./WarningOption.vue?vue&type=script&lang=js"
import style0 from "./WarningOption.vue?vue&type=style&index=0&id=55310138&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports